import DocumentService from '@/Modules/Document/DocumentService.js'

export default class ClientDocumentService extends DocumentService {
  static resource = 'clients'
}
